module.exports = __webpack_public_path__ + "static/Atmo-7c3e0612051cf9e3fc2cb8ec705a11f6.jpg";